'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = isIOS;
function isIOS() {
  var userAgent = window.navigator.userAgent;
  return Boolean(userAgent.match(/iPad|iPhone|iPod/)) && !window.MSStream;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/mobile.js
// module id = 295
// module chunks = 0 1